import {Box} from '@mui/material';
import {usePullToRefresh} from 'hooks/generalHooks';
import {ReactNode} from 'react';
import LoadingSpinner from './animation/LoadingSpinner';
import {ScrollableStack} from './layout/ScrollableStack';

export default function PullToRefreshBox(props: {children: ReactNode; onRefresh: () => Promise<void>}) {
	const {children, onRefresh} = props;

	const threshold = 20;
	const {containerRef, isPulling, pullDistance} = usePullToRefresh(onRefresh, {
		threshold,
		maxPull: 150,
		baseResistance: 0.4,
	});

	return (
		<ScrollableStack ref={containerRef}>
			{(isPulling || pullDistance >= threshold) && (
				<Box id="loading-spinner" paddingBottom="20px">
					<LoadingSpinner size={40} />
				</Box>
			)}

			{children}
		</ScrollableStack>
	);
}
